import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';

const GLOBAL = require('../../Globals');

class LeaveDeduction extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			dept : '',
			employee : '',
			year : (new Date()).getFullYear(),
			month : '',
			available : '',
			wrkdays : '',
			total : '',
			leave : '',
			ot : '',
			depart : [],
			accyear : [],
			emp : [],
			payhe : [],
			desig : '',
			noofdays : '',
			_message : '',
			alertClass :'',
			_redirect : false,
			 posts: [],
			 salary : [],
			 count : '',
			 leave : '',
			 leavemonth : '',
			 total : '',
			 modal: false,
			 deduct : [],
			 noofdeduct : '',
			 noded : ''
		}
		this.onChange = this.onChange.bind(this);
		this.handleClick = this.handleClick.bind(this);
		// this.handleChange = this.handleChange.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.toggle = this.toggle.bind(this);
	}
	
	toggle(){
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	onClick(e){
		
		document.getElementById("salform").reset();
	}
	
	handleChange(id,e){
		
		this.state.employee = id;
		this.state.noofdeduct = e.target.id;
		this.state.noofded = e.target.id;
		// alert(e.target.id);
		this.setState({
		  modal: !this.state.modal
		});
	}
	
	/** set value **/
	onChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);	
	}
	
	onSubmit(e){
		
		e.preventDefault();
		$("#showLoader").show();
		PostData('payroll/leaveentry',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			
			if(responseJson.status == '1' ){
				this.toggle();
				this.getleavededuct();
			}
			else{
				this.toggle();
				this.getleavededuct();
			}
		});
		
	}
	
	/** remove function **/
	handleClick(dd){
		
		this.state.id = dd;
		console.log('id'+this.state.id);
		
		if (window.confirm("Do you want to Delete?")) {
				$("#showLoader").show();
			PostData('payroll/deletesalset',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				console.log(responseJson);
				if(responseJson.status == '1'){
					this.setState({
						_message:'Salary Settings Removed Successfullly',
						alertClass:'alert alert-success'
					});
					this.getdata();
				}
				else{
			
					this.setState({
						_message:'Error in Remove Salary Settings',
						alertClass:'alert alert-danger'
					});
				}
			});
		}		
	}
	
	onUpdate(dt){
		
		this.state.idd = dt;
		this.setState({_redirect: true});
		
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdata();
		this.getacyear();
		this.getemployee();
		this.getleavededuct();
	}
	
	getleavededuct(){
		$("#showLoader").show();
		GetData('payroll/getleave').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					deduct : responseJson
				});
			}
		});
	}
	
	/** get Academic Year **/
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear : academic
				});
				$('#year option').eq(1).prop('selected', true).trigger('change');
			}
		});
	}
	
	/** get Department **/
	getdepartment(){
		
		GetData('department/getdepartment').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					depart : responseJson
				});
			}
		});
	}
	
	/** get Employee **/
	getemployee(){
		
		// var cs = $("#depart").val();
		GetData('employee/getemployee').then((result) => {
			
			let responseJson = result;
			if(responseJson){
				this.setState({
					emp : responseJson
				});
			}
		});
	}
	
	getdata(){
		
		GetData('employee/getattend').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	getleaveupto(empid){
		
		var dat = [];
		
		if(this.checkleave(empid)!=''){
			
			dat.push(<td>{this.checkleave(empid)}</td>);
		}
		else{
			
			dat.push(<td></td>);
		}
		
		return dat;
	}
	
	checkleave(emp){
		
		var bstate = 0;
		var ac = $("#year").val();
		var year = this.state.year;
		
		for(var ii=0; ii < this.state.posts.length; ii++){
			
			if(this.state.posts[ii].acyear == ac && this.state.posts[ii].year == year && this.state.posts[ii].employee == emp){
				
				bstate ++;
			}
		} 
		// console.log(bstate);
		return bstate;
	}
	
	getleavethismonth(empid){
		
		var dat = [];
		
		if(this.checkleavethismonth(empid)!=''){
			
			dat.push(<td>{this.checkleavethismonth(empid)}</td>);
		}
		else{
			
			dat.push(<td></td>);
		}
		
		return dat;
	}
	
	checkleavethismonth(emp){
		
		var bstate = 0;
		var ac = $("#year").val();
		var year = this.state.year;
		var month = $("#month").val();
		
		for(var i=0;i<this.state.posts.length;i++){
			
			if(this.state.posts[i].acyear == ac && this.state.posts[i].year == year && this.state.posts[i].month == month && this.state.posts[i].employee == emp){
				
				bstate ++;
			}
		}
		return bstate;
	}
	
	getnoofdeduct(emp){
		
		var dat1 = [];
		
		if(this.checkdeduct(emp)!=''){
			
			dat1.push(<td>{this.checkdeduct(emp)}</td>);
		}
		else{
			
			dat1.push(<td>{this.checkleavethismonth(emp)}</td>);
		}
		
		return dat1;
	}
	
	
	checkdeduct(emp){
		
		var bstate = false;
		var ac = $("#year").val();
		var year = this.state.year;
		var month = $("#month").val();
		
		for(var j=0;j<this.state.deduct.length;j++){
			
			if(this.state.deduct[j].acyear == ac && this.state.deduct[j].year == year && this.state.deduct[j].employee == emp && this.state.deduct[j].month == month){
				
				bstate = this.state.deduct[j].noofdeductdays;
				break;
			}
			else{
				
				 bstate = false;
			}
		}
		
		return bstate;
	}
	
  render() {
	
	var dept = this.state.depart;
	var acyear = this.state.accyear;
	var employ = this.state.emp;
	
	/** set month in select box **/
	  this.month = [
		{value : '', name: 'Select Month'},
		{value : '01', name: 'January'},
		{value : '02', name: 'February'},
		{value : '03', name: 'March'},
		{value : '04', name: 'April'},
		{value : '05', name: 'May'},
		{value : '06', name: 'June'},
		{value : '07', name: 'July'},
		{value : '08', name: 'August'},
		{value : '09', name: 'September'},
		{value : '10', name: 'October'},
		{value : '11', name: 'November'},
		{value : '12', name: 'December'}
	];
		
	if(this.state.acyear!='' && this.state.month){
		
		$("#leaveded").show();
	}
	else{
		
		$("#leaveded").hide();
	}
	
	/* $("#noofdays").change(function(){
		
		var noofday = $(this).val();
		
		if(noofday > this.state.noded){
			
			// $(this).val('');
			alert('please check leave this month');
		}
	}); */
	
	var noded = $("#noofdays").val();
	
	if(noded > this.state.noofded){
		
		$("#noofdays").val('');
		this.state.noofdeduct = '';
		alert('please check leave this month');
	}
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="12">
				<Card>
				  <form action="" method="post" role="form" id="salform" encType="multipart/form-data" onSubmit={this.onSubmit}>
					<CardHeader>
						<strong>Leave Deduction</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
						Academic Year : &nbsp;&nbsp;
						<select name="acyear" onChange={this.onChange} required id="year">
							<option value="">Select Academic Year</option>
							{
								acyear.map(function (item) {
									return <option value={item.id }>{item.value}</option>;
								})
							}
						</select>&nbsp;&nbsp;
						Month : &nbsp;&nbsp;
						<select name="month" onChange={this.onChange} required id="month">
							{this.month.map((e, key) => {
								return <option key={key} value={e.value}>{e.name}</option>;
							})}		
						</select>
					</CardHeader>
					<CardBody id="leaveded">
					 <Row>
					  <Col md="12">
						<Table responsive bordered >
						  <thead>
							<tr>
								<th>S.No</th>
								<th>Employee Name</th>
								<th>Leave Upto this month</th>
								<th>Leave this month</th>
								<th>Days Deduction</th>
								<th>Manage</th>
							</tr>
						  </thead>
						  <tbody>
							{this.state.emp.map((item,i) =>
						 
								<tr key = {item}>
									<td>{i+1}</td>
									<td>{item.empname}</td>
									{this.getleaveupto(item.id)}
									{this.getleavethismonth(item.id)}
									{this.getnoofdeduct(item.id)}
									<td>
										<Button size="sm" color="primary" id={this.checkleavethismonth(item.id)} onClick={this.handleChange.bind(this,item.id)} >Edit</Button>
									</td>
								</tr>
							)}
						  </tbody>
						</Table>
						<Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
						  <ModalHeader toggle={this.toggle}>Select</ModalHeader>
						  <ModalBody>
							<Row>
							  <Col md="12">
							   <FormGroup>
								<Label htmlFor="name">No of days Deduct <span className="text-danger">*</span></Label>
								<input type="number" name="noofdeduct" id="noofdays" value={this.state.noofdeduct} className="form-control" onChange={this.onChange}/>
							   </FormGroup>
							  </Col>
							</Row>
						  </ModalBody>
						  <ModalFooter>
							<Button type="submit" color="primary" onClick={this.onSubmit}>Submit</Button>
							<Button color="secondary" onClick={this.toggle}>Cancel</Button>
						  </ModalFooter>
					  </Modal>
					  </Col>
					 </Row>
					</CardBody>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default LeaveDeduction;


// WEBPACK FOOTER //
// ./src/payroll/LeaveDeduction/LeaveDeduction.js